import CRUD from './genericCRUD'

const route = 'license_holders'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function licenseHolders(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {number} isActive
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, isActive, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''
			const isActiveParam = isActive ? `isActive=${isActive}&` : ''

			return instance.get(`${route}?${params}${nameParam}${isActiveParam}`, config)
		},
		getActive: (config = {}) => {

			return instance.get(`${route}?isActive=true`, config)
		}
	}
}
